import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormService } from '@core/services';

type FormErrors = {
  phone: string
}

@Component({
  selector: 'app-phone-card',
  templateUrl: './phone-card.component.html',
  styleUrls: ['./phone-card.component.scss']
})
export class PhoneCardComponent implements OnInit {

  @Input() titleText: string;
  @Input() btnText: string;

  @Input()
  get loading(): boolean {
    return this._loading;
  }

  set loading(value: boolean) {
    this._loading = value;
  }

  @Input()
  set serverErrors (errors) {
    if (errors) {
      this.formService.serverValidateForm(this.phoneForm, errors, this.errorMap);
    }
  }

  @Output() serverErrorsChange = new EventEmitter();

  @Output() onSubmit = new EventEmitter();

  _loading = false;


  errorMap = {
    country_code: 'phone',
    phone_number: 'phone'
  };

  phoneForm: FormGroup;

  constructor(
    public form: FormBuilder,
    public formService: FormService,
  ) { }

  ngOnInit() {
    this.buildForm();
  }

  public buildForm() {
    this.phoneForm = this.form.group({
      phone: [null, [Validators.required]]
    });
  }

  submit () {
    this._loading = true;

    this.formService.markFormGroupTouched(this.phoneForm);

    if (this.phoneForm.invalid) {
      return this._loading = false;
    }

    this.onSubmit.emit(this.phoneForm.controls.phone.value);
  }

}
